export default "__VITE_ASSET__BnPy5jaK__"